import $http from "./http";

//指标数据录入--指标list
export const getIsCollectedList = () => {
    return $http.post("/collect/targetMain/getIsCollectedList");
};

//指标数据录入--采集点树
export const getTargetPointList = data => {
    return $http.post("/collect/common/getTargetPointList", data);
};

//获取部门统计公式树
export const getTargetUnitTreeList = data => {
    return $http.post("/collect/target_unit/getTargetUnitTreeList", data);
};

//保存树节点
export const saveTargetUnitTree = data => {
    return $http.post("/collect/target_unit/saveTargetUnitTree", data);
};

//删除树节点
export const delTargetUnitTree = data => {
    return $http.post("/collect/target_unit/delTargetUnitTree", data);
};

//获取指标树
export const getTargetMainList = data => {
    return $http.post("/collect/targetMain/getTargetMainList", data);
};

//保存公式
export const saveTargetExpression = data => {
    return $http.post("/collect/target_unit/saveTargetExpression", data);
};

//查询公式
export const getTargetExpressionById = data => {
    return $http.post("/collect/target_unit/getTargetExpressionById", data);
};

//删除公式
export const delTargetExpression = data => {
    return $http.post("/collect/target_unit/delTargetExpression", data);
};

//指标数据录入--获得指标表头
export const getTargetMainDtlList = data => {
    return $http.post("/collect/targetMain/getTargetMainDtlList", data);
};

//指标数据录入--获得指标数据
export const getTargetMainDtlDataList = data => {
    return $http.post("/collect/targetMain/getTargetMainDtlDataList", data);
};

//指标数据录入--获得指标列表数据
export const getShowDayList = data => {
    return $http.post("/collect/targetMain/getShowDayList", data);
};

//指标数据录入--添加录入数据
export const insertTargetDtlData = data => {
    return $http.post("/collect/targetMain/insertTargetDtlData", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//指标数据录入--修改录入数据
export const updateTargetDtlData = data => {
    return $http.post("/collect/targetMain/updateTargetDtlData", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//指标新增和修改保存
export const saveTargetMain = data => {
    return $http.post("/collect/targetMain/saveTargetMain", data);
};

//指标详细
export const getTargetMainById = data => {
    return $http.post("/collect/targetMain/getTargetMainById", data);
};

//删除指标
export const deleteTargetMainById = data => {
    return $http.post("/collect/targetMain/deleteTargetMainById", data);
};

//获取指标采集点树
export const getTargetDtls = data => {
    return $http.post("/collect/common/getPointList", data);
};

//获取指标采集点树
export const getTargetDtls1 = data => {
    return $http.post("/collect/targetMain/getTargetDtls", data);
};
//指标和采集点关系保存
export const saveTargetPoints = data => {
    return $http.post("/collect/targetMain/saveTargetPoints", data);
};

//指标的字段保存
export const saveTargetDtls = data => {
    return $http.post("/collect/targetMain/saveTargetDtls", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//获取指标采集点树
export const getPointTree = data => {
    return $http.post("/collect/target_unit/getPointTree", data);
};
